import {
  APIgetClientUsage,
  APIgetClients,
} from '../api/Clients';

export const SET_CLIENT_USAGE = 'SET_CLIENT_USAGE';

export const setClientUsage = usage => ({
  type: SET_CLIENT_USAGE,
  usage,
});

export const fetchClientUsage = () => dispatch => (
  APIgetClientUsage()
    .then((response) => {
      dispatch(setClientUsage(response.data));
      return response.data;
    })
    .catch(error => (error))
);

export const fetchClients = params => (
  APIgetClients(params)
    .then(response => (response.data))
    .catch(error => (error))
);
